import { QueryClientConfig } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import { isNetworkError } from 'axios-retry';

const queryClientConfig: QueryClientConfig = {
  defaultOptions: {
    queries: {
      gcTime: 1000 * 60 * 3, // 3 minutes
      // Pay attention to all of the instances of `isFetchedAfterMount` in the codebase.
      // staleTime: 1000 * 60 * 3,
      refetchOnWindowFocus: false,
      retry: false,
      throwOnError: (error, _query) => {
        if (isNetworkError(error)) {
          return false;
        }

        if (isAxiosError(error) && error.response?.status === 422) {
          return false;
        }

        return true;
      }
    },
    mutations: {
      throwOnError: error => {
        if (isNetworkError(error)) {
          return false;
        }

        if (isAxiosError(error) && error.response?.status === 422) {
          return false;
        }

        return true;
      }
    }
  }
};

export default queryClientConfig;
